// extracted by mini-css-extract-plugin
export default {"wrapper":"SidebarLayout_wrapper__9XO4f","container":"SidebarLayout_container__QqmAe"};